import {
  FC,
  JSX,
  useState,
  ReactNode,
} from "react";
import { View, Text, Pressable } from "react-native";

export interface TabsItem {
  key: string;
  label: string;
  children: ReactNode;
}

export interface ITabsProps {
  items: TabsItem[];
  defaultActiveKey?: string;
  onChange?: (activeKey: string) => void;
}

const Tabs: FC<ITabsProps> = ({
  items,
  defaultActiveKey,
  onChange,
}): JSX.Element => {
  const [activeKey, setActiveKey] = useState<string>(defaultActiveKey || items[0]?.key);

  const handlePress = (key: string): void => {
    setActiveKey(key);
    onChange?.(key);
  };

  const activeItem: TabsItem | undefined = items.find(({ key }: TabsItem) => key === activeKey);

  const renderTabsItems = (): JSX.Element[] => items.map(({ key, label }: TabsItem) => {
    const isActive: boolean = key === activeKey;

    return (
      <Pressable
        key={key}
        onPress={() => handlePress(key)}
        className={`py-2 px-4 mr-2 rounded-xl transition-all duration-200 ${isActive ? "bg-black" : "bg-gray-light"}`}
      >
        <Text className={`text-center transition-all duration-200 ${isActive ? "text-white" : "text-black"}`}>
          {label}
        </Text>
      </Pressable>
    );
  });

  const renderActiveItemChildren = (): ReactNode => typeof activeItem?.children === "string"
    ? <Text>{activeItem.children}</Text>
    : activeItem?.children;

  return (
    <View className="flex-1">
      <View className="flex-row mb-4">{renderTabsItems()}</View>
      <View className="flex-1">{renderActiveItemChildren()}</View>
    </View>
  );
};

export default Tabs;
